import { Component, DoCheck, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ClientsService } from 'src/app/services/clients.service';

@Component({
    selector: 'app-clients',
    templateUrl: './clients.component.html',
    styleUrl: './clients.component.scss',
    standalone: false
})
export class ClientsComponent implements OnInit, DoCheck {
	clientsObserve!: Observable<any[]>;
	clients: any[] = [];
  isSidebarVisible = false;

	constructor(public clientsService: ClientsService, private authService: AuthService, private router: Router) {}

	async ngOnInit() {
		if (this.authService.currentClientValue.client_id === 0) {
			await this.clientsService.getClients();
			this.clientsObserve = this.clientsService.clients$;
	
			this.clientsObserve.subscribe((clients: any[]) => {
				this.clients = clients;
			});

			this.clientsService.leftSideBarEvent$.subscribe((show: boolean) => {
				this.isSidebarVisible = show;
			})
		}
	}
	
	ngDoCheck(): void {
		if (this.clients.length > 0) {
			if (this.router.url === '/clients') {
				this.router.navigate(['clients/' + this.clients[0].id]);
			}
		}
	}

	toggleSidebar(event: boolean) {
		this.isSidebarVisible = event;
	}
}
